import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "bi bi-x-lg text-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-sm btn-danger d-flex align-items-center justify-content-center",
    title: _ctx.btnText || 'Excluir'
  }, [
    (_ctx.btnText)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.btnText), 1))
      : (_openBlock(), _createElementBlock("i", _hoisted_3))
  ], 8, _hoisted_1))
}